import React from 'react'
import { IconBook, IconTrendingUp, IconUsers } from '@tabler/icons-react'
import SectionTitle from './shared/SectionTitle'

export default function SupportSection() {
  const services = [
    {
      icon: IconUsers,
      title: '专属顾问协助制定使用规范',
      description: '根据你的业务场景，协助梳理「什么情况需要查、查完怎么用」，帮你明确查询流程与内部留痕规范',
    },
    {
      icon: IconBook,
      title: '标准操作指南与培训',
      description: '提供简单易懂的操作指南与短视频讲解，可为关键岗位员工安排远程培训，让团队尽快熟悉使用方式',
    },
    {
      icon: IconTrendingUp,
      title: '持续优化使用效果',
      description: '根据你的反馈，协助调整查询策略与报告展现方式，让风险识别更贴近你的业务特点，而不是「一刀切」',
    },
  ]

  return (
    <section className="py-32 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 lg:px-12 relative z-10">
        <SectionTitle title="不仅有工具，更有团队帮你一起把关" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl p-8 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 border border-gray-100"
            >
              <div className="absolute -top-3 -left-3 w-6 h-6 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              <div className="mb-6">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-orange-50 to-orange-100 flex items-center justify-center">
                  <service.icon size={28} className="text-orange-600" />
                </div>
              </div>

              <h3 className="text-lg font-bold text-gray-900 mb-4 leading-snug">{service.title}</h3>

              <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-lg text-gray-600 font-medium max-w-2xl mx-auto relative inline-block">
            <span className="absolute -left-4 top-0 text-orange-400 text-4xl leading-none">"</span>
            我们的目标不是「卖你一个系统」，而是帮你把风险真正拦在门外
            <span className="absolute -right-4 bottom-0 text-orange-400 text-4xl leading-none">"</span>
          </p>
        </div>
      </div>
    </section>
  )
}
